(function() {
    'use strict';

    angular
        .module('alpha.common.services.navigation', [
            'AlphaApi',
            'UserPreferences',
            'alpha.utils.I18n',
            'alpha.utils.recordData',
            'alpha.common.services.authentication',
            'alpha.common.services.security',
            'alpha.common.services.alphaTabManager'
        ])
        .factory('NavigationService', NavigationService);

    NavigationService.$inject = [
        'DataModelDesignInterface',
        'UserPreferences',
        'I18nUtil',
        'RecordDataUtil',
        'AuthenticationService',
        'SecurityService',
        'AlphaTabManagerService',
        '$q',
        '$http',
        '$window',
        '$rootScope'
    ];

    function NavigationService(
        DataModelDesignInterface,
        UserPreferences,
        I18nUtil,
        RecordDataUtil,
        AuthenticationService,
        SecurityService,
        AlphaTabManagerService,
        $q,
        $http,
        $window,
        $rootScope
    ) {
        var MODULE_TITLES = {
                businessIntelligence: I18nUtil.getI18nString('TAB_BI', 'Business Intelligence'),
                dataDiscovery: I18nUtil.getI18nString('MENUITEM_DATA_DISCOVERY', 'Data Discovery'),
                dataGovernance: I18nUtil.getI18nString('LBL_DATA_GOVERNANCE', 'Data Governance'),
                digital: I18nUtil.getI18nString('LBL_DIGITAL', 'Digital'),
                exchangeRates: I18nUtil.getI18nString('TAB_EXCHANGE_RATES', 'Exchange Rates'),
                formLetters: I18nUtil.getI18nString('TAB_FORM_LETTERS', 'Form Letters'),
                groupManagement: I18nUtil.getI18nString('TAB_GROUP_MANAGEMENT', 'Groups'),
                myProfile: I18nUtil.getI18nString('TAB_MY_PROFILE', 'My Profile'),
                quickSearch: I18nUtil.getI18nString('TAB_QUICK_SEARCH', 'Quick Search'),
                recentRecords: I18nUtil.getI18nString('LBL_RECENT_RECORDS', 'Recent Records'),
                reports: I18nUtil.getI18nString('TAB_REPORTS', 'Reports'),
                search: {
                    global: I18nUtil.getI18nString('TAB_GLOBAL_SEARCH', 'Global Search'),
                    map: I18nUtil.getI18nString('TAB_MAP_SEARCH', 'Map Search')
                },
                spreadsheetUpload: I18nUtil.getI18nString('TAB_SPREADSHEET_UPLOAD', 'Spreadsheet Upload'),
                structuredSearch: I18nUtil.getI18nString('TAB_ADVANCED_QUERY', 'Advanced Query'),
                userManagement: I18nUtil.getI18nString('TAB_USER_MANAGEMENT', 'Users'),
                viewRecord: I18nUtil.getI18nString('LBL_RECORD_DETAIL_PAGE', 'Record Detail Page'),
                workflowAutomation: I18nUtil.getI18nString('TAB_WORKFLOW_AUTOMATION', 'WorkFlow Automation'),
                dataScience: I18nUtil.getI18nString('MENUITEM_DATA_SCICENCE', 'Data Science'),
                changepassword : I18nUtil.getI18nString('TAB_CHANGE_PASSWORD', 'Change Password'),
                DM_lookupLibraries : I18nUtil.getI18nString('LBL_DM_WORKBENCH', 'Data Model Workbench'),
                LBL_WORKBENCH_HOME : I18nUtil.getI18nString('LBL_WORKBENCH_HOME', 'Workbench Home'),
                LBL_UI_WORKBENCH : I18nUtil.getI18nString('LBL_UI_WORKBENCH', 'UI Workbench'),
                LBL_DM_WORKBENCH : I18nUtil.getI18nString('LBL_DM_WORKBENCH', 'Data Model Workbench'),
                LBL_BR_WORKBENCH : I18nUtil.getI18nString('LBL_BR_WORKBENCH', 'Business Rules Workbench'),
                LBL_BO_WORKBENCH : I18nUtil.getI18nString('LBL_BO_WORKBENCH', 'Business Object Workbench'),
                LBL_BI_WORKBENCH : I18nUtil.getI18nString('LBL_BI_WORKBENCH', 'Business Intelligence Workbench'),
                LBL_DATA_INTEGRITY : I18nUtil.getI18nString('LBL_DATA_INTEGRITY', 'Data Integrity'),
                LBL_CLIENT_INFORMATION : I18nUtil.getI18nString('LBL_CLIENT_INFORMATION', 'Client Information')
            },
            MODULE_ICONS = {
                businessIntelligence: 'icon-ic_report',
                dataDiscovery: 'icon-ic_report',
                dataGovernance: 'icon-ic_report',
                digital: 'icon-ic_report',
                exchangeRates: 'icon-ic_report',
                formLetters: 'icon-ic_form_letter',
                groupManagement: 'icon-ic_group_top_mgmt',
                quickSearch: 'icon-ic_history',
                reports: 'icon-ic_report',
                spreadsheetUpload: 'icon-ic_report',
                userManagement: 'icon-ic_user_tab',
                workflowAutomation: 'icon-ic_group_top_mgmt',
                dataScience: 'icon-ic_report'
            },
            MODULE_AUTHORITIES = {
                businessIntelligence: ['ShowAdministrationSetting', 'BusinessIntelligenceAuthority'],
                dataDiscovery: ['AnalyticsAuthority', 'DataDiscoveryAuthority'],
                dataGovernance: ['ShowAdministrationSetting', 'DataGovernanceAuthority'],
                exchangeRates: ['ShowAdministrationSetting', 'RateSchemeAuthority'],
                formLetters: ['ShowAdministrationSetting', 'FormLetterAuthority'],
                groupManagement: ['ShowAdministrationSetting', 'SecurityAssignmentAuthority'],
                quickSearch: ['RecordMenuAuthority'],
                recentRecords: ['RecordMenuAuthority', 'RecentRecordAuthority'],
                reports: ['AnalyticsAuthority', 'ReportAuthority'],
                riskOneTools: {
                    riskOneTools: ['ShowAdministrationSetting', 'DataModelDesignAuthority', 'BusinessRulesWorkbenchAuthority', 'BusinessObjectWorkbenchAuthority', 'UIWorkbenchAuthority'],
                    lookupLibraries: ['ShowAdministrationSetting', 'LookupMaintenanceAuthority']
                },
                search: {
                    global: ['AnalyticsAuthority', 'GlobalSearchAuthority'],
                    map: ['AnalyticsAuthority', 'MapSearchAuthority']
                },
                spreadsheetUpload: ['RecordMenuAuthority', 'SpreadSheetUploadAuthority'],
                structuredSearch: ['AnalyticsAuthority', 'AdvanceQueryAuthority'],
                userManagement: ['ShowAdministrationSetting', 'SecurityAssignmentAuthority'],
                workflowAutomation: ['ShowAdministrationSetting', 'WorkFlowAutomationAuthority'],
                dataScience: ['AnalyticsAuthority', 'DataScienceAuthority'],
            },
            TOGGLZ_KEYS = 'ENABLE_LEGACY_ADVANCED_QUERY,ENABLE_LEGACY_REPORTS,ENABLE_LEGACY_FORM_LETTERS,ENABLE_LEGACY_USER_MANAGEMENT,ENABLE_LEGACY_GLOBAL_SEARCH,ENABLE_LEGACY_MY_PROFILE,ENABLE_LEGACY_CHANGE_PASSWORD,' +
                'ENABLE_LEGACY_EXCHANGE_RATES,ENABLE_LEGACY_GROUP_MANAGEMENT,ENABLE_LEGACY_SPREADSHEET_UPLOAD,ENABLE_LEGACY_DATA_GOVERNANCE,' +
                'ENABLE_LEGACY_VIEW_DATA_LOADS,ENABLE_LEGACY_QUICK_SEARCH,ENABLE_LEGACY_MAP_SEARCH,ENABLE_LEGACY_BI_WORKBENCH,ENABLE_LEGACY_WFA_TBE_MANAGEMENT,ENABLE_LEGACY_DASHBOARD,' +
                'ENABLE_LEGACY_RISK_ONE_TOOLS,ENABLE_LEGACY_DM_WORKBENCH,ENABLE_LEGACY_CLIENT_SETTINGS',
             _tabCounter = 0,
            _currentUserAuthorities,
            _togglzDataPromise;

        return {
            openModuleTab: openModuleTab,
            openModuleWindow: openModuleWindow,
            getModuleUrl: getModuleUrl,
            getModuleTitle: getModuleTitle,
            getModuleIcon: getModuleIcon,
            moduleIsAvailable: moduleIsAvailable,
            logOut: logOut
        };

        function _ensureTogglzData() {
            if (!_.isEmpty($rootScope.togglzData)) {
                return $q.when($rootScope.togglzData);
            }

            if (_togglzDataPromise) {
                return _togglzDataPromise;
            }

            var deferred = $q.defer();
            _togglzDataPromise = deferred.promise;

            DataModelDesignInterface.getTogglzValues(TOGGLZ_KEYS, function success(data) {
                $rootScope.togglzData = data || {};
                deferred.resolve($rootScope.togglzData);
            }, function error() {
                deferred.resolve($rootScope.togglzData);
            });

            return _togglzDataPromise;
        }

        // Public methods
        /**
         * Opens a module in a new application tab.
         *
         * @method openModuleTab
         *
         * @param {String} name Name of the module
         * @param {String} [id] Tab ID if needed
         * @param {String} [title] Tab title if needed
         * @param {Object} [options] Options for modules that support them
         */
        function openModuleTab(name, id, title, options) {
            var icon = this.getModuleIcon(name);
            var togglzReadyPromise = _.isEmpty($rootScope.togglzData)
                ? _ensureTogglzData()
                : $q.when($rootScope.togglzData);
            if (!id) {
                id = name + '__' + _tabCounter++;
            }
            if (!title) {
                title = this.getModuleTitle(name, options);
            }
            togglzReadyPromise.then(function() {
                return getModuleUrl(name, options);
            }).then(function(url) {
                if (name === 'businessIntelligence' && id) {
                    _initBiFrame(id); // It is NOT safe to run this without an ID
                } else if (name === 'search' && options && options.doNotRunSearch) {
                    sessionStorage.setItem('doNotRunSearch', 1);
                }
                AlphaTabManagerService.addTab(id, title, url, icon, name);
            });
        }

        /**
         * Opens a module in a new browser window.
         *
         * @method openModuleWindow
         *
         * @param {String} name Name of the module
         * @param {Object} [options] Options for modules that support them
         */
        function openModuleWindow(name, options) {
            var togglzReadyPromise = _.isEmpty($rootScope.togglzData)
                ? _ensureTogglzData()
                : $q.when($rootScope.togglzData);

            togglzReadyPromise.then(function() {
                return getModuleUrl(name, options);
            }).then(function(url) {
                if (name === 'search' && options && options.doNotRunSearch) {
                    sessionStorage.setItem('doNotRunSearch', 1);
                }
                AuthenticationService.authenticateUser()
                    .then(function () {
                        if (name === 'riskOneTools') {
                            _openRiskOneTools(url, options);
                        } else {
                            $window.open(url);
                        }
                    });
            });
            function _openRiskOneTools(url, options) {
                url = _getRiskOneToolsOpenUrl(url, options);

                var topWindowAccessible = true;
                var isAngularV19Tools = _.includes(url, '/static/angular-v19/index.html#/riskOneTools');
                var isAngularV19SubModule = isAngularV19Tools && _.includes(url, 'subModule=');

                function _focusWorkbenchHome(targetWindow) {
                    if (!targetWindow) {
                        return;
                    }

                    try {
                        if (_.isObject(targetWindow.AlphaEventService) && _.isFunction(targetWindow.AlphaEventService.publish)) {
                            // Legacy tab manager expects the selected tab id as a string payload.
                            targetWindow.AlphaEventService.publish('AlphaTabManager', 'selectTab', 'tcor');
                        }
                    } catch (e) {
                    }

                    // Fallback: click the Workbench Home tab directly when event API differs.
                    try {
                        var homeTabLink = targetWindow.document && targetWindow.document.querySelector('#tcor-tab a');
                        if (homeTabLink && _.isFunction(homeTabLink.click)) {
                            homeTabLink.click();
                        }
                    } catch (e) {
                    }
                }
                /* TODO:
                    This logic came from MainController. It was for AL-5620. It isn't clear why so much
                    complexity is needed for such a basic task of opening a window, but I can't look at
                    this due to time constraints. This might cause a memory leak because it's storing a
                    reference to another window. It needs to be looked at. */
                if (!_.includes(url, '#')) {
                    url += '#';
                }
                if (!isAngularV19Tools) {
                    var counter = new Date().getTime();
                    if (!_.endsWith(url, '/')) {
                        url += '/';
                    }
                    url += counter;
                }

                try{
                    var winUrl = $window.top.url; //Check if top window is accessible. For example if IRM is loaded inside VentivOne portal, top window is not accessible due to cross site security.
                    if(!winUrl){ //iOS
                        topWindowAccessible = false;
                    }
                }catch(e){
                    topWindowAccessible = false;
                }

                if(topWindowAccessible) {
                    if (typeof($window.top.window.riskonetoolsWindow) === 'undefined' || $window.top.window.riskonetoolsWindow.closed) {
                        $window.top.window.riskonetoolsWindow = $window.top.window.open(url, 'riskonetools');
                    } else {
                        if (isAngularV19Tools) {
                            var existingInV19Shell = false;
                            try {
                                var existingHref = $window.top.window.riskonetoolsWindow.location && $window.top.window.riskonetoolsWindow.location.href;
                                // Keep Angular v19 Tools state intact on re-click:
                                // if the existing window is already in the v19 shell, don't force navigation.
                                existingInV19Shell = _.includes(existingHref || '', '/static/angular-v19/index.html');
                                if (!existingInV19Shell) {
                                    $window.top.window.riskonetoolsWindow.location = url;
                                }
                            } catch (e) {
                                $window.top.window.riskonetoolsWindow.location = url;
                            }

                            // Match AngularJS behavior: selecting Tools again should point to Workbench Home.
                            if (existingInV19Shell) {
                                if (isAngularV19SubModule) {
                                    $window.top.window.riskonetoolsWindow.location = url;
                                } else {
                                    _focusWorkbenchHome($window.top.window.riskonetoolsWindow);
                                }
                            }
                        } else {
                            $window.top.window.riskonetoolsWindow.location = url;
                        }
                        $window.top.window.riskonetoolsWindow.focus();
                    }
                } else {
                    if (isAngularV19Tools) {
                        if (typeof($window.riskonetoolsWindow) === 'undefined' || $window.riskonetoolsWindow.closed) {
                            $window.riskonetoolsWindow = $window.open(url, 'riskonetools');
                        } else {
                            if (isAngularV19SubModule) {
                                $window.riskonetoolsWindow.location = url;
                            } else {
                                _focusWorkbenchHome($window.riskonetoolsWindow);
                            }
                            $window.riskonetoolsWindow.focus();
                        }
                    } else {
                        $window.riskonetoolsWindow = $window.open(url, 'riskonetools');
                    }
                }
            }

            function _getRiskOneToolsOpenUrl(url, options) {
                if (_isAngularLookupMaintenance(options)) {
                    return applicationContextRoot + '/static/angular-v19/index.html#/riskOneTools?subModule=lookupLibraries';
                }
                return url;
            }
        }

        function _isAngularLookupMaintenance(options) {
            return options && options.subModule === 'lookupLibraries' &&
                (options.angularLookupMaintenance === true ||
                    _.get($rootScope.togglzData, 'ENABLE_LEGACY_DM_WORKBENCH') === 'Angular');
        }

        /**
         * Provides a full URL of a module.
         *
         * @method getModuleUrl
         *
         * @param {String} name Name of the module
         * @param {Object} [options] Options for modules that support them
         *
         * @returns {Promise} A promise to be resolved with the URL of the module
         */
        function getModuleUrl(name, options) {
            var deferred = $q.defer();
            switch (name) {
                case 'businessIntelligence':
                    if (options && options.url) {
                        deferred.resolve(options.url);
                    } else {
                        _getBiUrl();
                    }
                    break;
                case 'dataDiscovery':
                    _getBiUrl();
                    break;
                case 'dataScience':
                    _getDataScienceUrl();
                    break;
                case 'digital':
                    _getDigitalUrl();
                    break;
                case 'viewRecord':
                    _getRecordDetailUrl();
                    break;
                default:
                    _getModuleUrl();
            }
            function _getBiUrl() {
                UserPreferences.getClientId()
                    .then(function(clientId) {
                        DataModelDesignInterface.getClientFromCache(
                            clientId,
                            function success(response) {
                                var url = name === 'dataDiscovery' ? response.client.urlBiDataDiscovery : response.client.urlBi;
                                deferred.resolve(url);
                            },
                            function error(response) {
                                deferred.reject(response.data.errorMessage);
                            }
                        );
                    })
                    .catch(function(reason) {
                        deferred.reject(reason);
                    });
            }
            function _getDigitalUrl() {
                DataModelDesignInterface.getDigitalProperties(
                    function success(props) {
                        $http.post(props.hostname + '/auth/irm', {token: props.token})
                            .then(function(response) {
                                var url = options && options.url ? options.url : props.hostname;
                                url += _.includes(url, '?') ? '&' : '?';
                                url += 'irm_token=' + response.data.token;
                                deferred.resolve(url);
                            })
                            .catch(function(response) {
                                deferred.reject(response);
                            });
                    },
                    function error(response) {
                        deferred.reject(response.data.errorMessage);
                    }
                );
            }
            function _getRecordDetailUrl() {
                UserPreferences.getClientId()
                    .then(function(clientId) {
                        var url = RecordDataUtil.getRecordDetailUrl(clientId, options.recordType);
                        deferred.resolve(url);
                    })
                    .catch(function(reason) {
                        deferred.reject(reason);
                    });
            }
            function _getDataScienceUrl() {
                UserPreferences.getClientId()
                    .then(function(clientId) {
                        DataModelDesignInterface.getClientFromCache(
                            clientId,
                            function success(response) {
                                var url =  response.client.dataScienceDomain + response.client.urlDataScience;
                                deferred.resolve(url);
                            },
                            function error(response) {
                                deferred.reject(response.data.errorMessage);
                            }
                        );
                    })
                    .catch(function(reason) {
                        deferred.reject(reason);
                    });
            }
            function _getModuleUrl() {
                var url = applicationContextRoot + '/static/custom/' + name + '/index.html';
                var angularUrl = applicationContextRoot + '/static/angular-v19/index.html#/';
                switch (name) {
                    case 'riskOneTools':
                        if (_isAngularLookupMaintenance(options)) {
                            url = applicationContextRoot + '/static/angular-v19/index.html#/riskOneTools?subModule=lookupLibraries';
                            break;
                        }
                        if (_.get($rootScope.togglzData, 'ENABLE_LEGACY_RISK_ONE_TOOLS') === 'Angular' &&
                            !(options && options.subModule)) {
                            url = angularUrl+'riskOneTools';
                            break;
                        }
                        if (options && options.subModule) {
                            url += '#/' + options.subModule + '/';
                        }
                        if (options && options.subModule === 'editLayout' && options.layoutName) {
                            url += options.layoutName + '/';
                        }
                        break;
                    case 'search':
                    case 'globalSearch':
                        var isAngularSearch = options && options.map
                            ? _.get($rootScope.togglzData, 'ENABLE_LEGACY_MAP_SEARCH') === 'Angular'
                            : _.get($rootScope.togglzData, 'ENABLE_LEGACY_GLOBAL_SEARCH') === 'Angular';
                        if(isAngularSearch){
                            url = angularUrl + 'globalSearch';
                        }
                        if (options && options.map) {
                            url += isAngularSearch ? '?searchType=map&searchTerm=*' : '#?searchType=map&searchTerm=*';
                        } else {
                            url += isAngularSearch ? '?searchType=refineSearch&searchTerm=&searchRecTypes=null' : '#?searchType=refineSearch&searchTerm=&searchRecTypes=null';
                        }
                        break;
                    case 'structuredSearch':
                        if (_.get($rootScope.togglzData, 'ENABLE_LEGACY_ADVANCED_QUERY') === 'Angular'){
                            url = angularUrl+'searchTable';
                        }
                        if (options && options.resultsView) {
                            url += '#/resultsView/' + options.resultsView;
                        }
                        break;
                    case 'quickSearch':
                        if(_.get($rootScope.togglzData, 'ENABLE_LEGACY_QUICK_SEARCH') === 'Angular'){
                            url = angularUrl+'quickSearchV19';
                            if (options && options.queryId) {
                                url += '/' + options.queryId;
                            }
                            break;
                        }
                        if (options && options.queryId) {
                            url += '#/' + options.queryId;
                        }
                        break;
                    case 'workflowAutomation':
                        if(_.get($rootScope.togglzData, 'ENABLE_LEGACY_WFA_TBE_MANAGEMENT') === 'Angular') {
                            url = angularUrl+'workflowAutomationV19';
                        }
                        break;
                    case 'userManagement':
                        if(_.get($rootScope.togglzData, 'ENABLE_LEGACY_USER_MANAGEMENT') === 'Angular') {
                            url = angularUrl+'userManagementV19';
                        }
                        break;
                    case 'groupManagement':
                        if(_.get($rootScope.togglzData, 'ENABLE_LEGACY_GROUP_MANAGEMENT') === 'Angular') {
                            url = angularUrl+'groupmanagement';
                        }
                        break;
                    case 'reports':
                        if(_.get($rootScope.togglzData, 'ENABLE_LEGACY_REPORTS') === 'Angular') {
                            url = angularUrl + 'reportsV19';
                        }
                        break;
                    case 'formLetters':
                        if(_.get($rootScope.togglzData, 'ENABLE_LEGACY_FORM_LETTERS') === 'Angular') {
                            url = angularUrl + 'formLettersAngularApp';
                        }
                        break;
                    case 'spreadsheetUpload':
                        if(_.get($rootScope.togglzData, 'ENABLE_LEGACY_SPREADSHEET_UPLOAD') === 'Angular') {
                            url = angularUrl + 'spreadSheetUploadV19';
                        }
                        break;
                    case 'exchangeRates':
                        if(_.get($rootScope.togglzData, 'ENABLE_LEGACY_EXCHANGE_RATES') === 'Angular') {
                            url = angularUrl + 'exchangeRates';
                        }
                        break;
                    case 'dataGovernance':
                        if(_.get($rootScope.togglzData, 'ENABLE_LEGACY_DATA_GOVERNANCE') === 'Angular') {
                            url = angularUrl + 'dataGovernance';
                        }
                        break;
                    case 'viewDataLoads':
                        if(_.get($rootScope.togglzData, 'ENABLE_LEGACY_VIEW_DATA_LOADS') === 'Angular') {
                            url = angularUrl + 'viewDataLoadsV19';
                        }
                        break;
                    case 'myProfile':
                        if(_.get($rootScope.togglzData, 'ENABLE_LEGACY_MY_PROFILE') === 'Angular') {
                            url = angularUrl + 'myProfileNg';
                        }
                        break;
                }
                deferred.resolve(url);
            }
            return deferred.promise;
        }

        /**
         * Provides a localized title of a module.
         *
         * @method getModuleTitle
         *
         * @param {String} name Name of the module
         * @param {Object} [options] Options for modules that support them
         *
         * @returns {String} The title of the module
         */
        function getModuleTitle(name, options) {
            if (name === 'search') {
                return options && options.map ? MODULE_TITLES.search.map : MODULE_TITLES.search.global;
            }
            return MODULE_TITLES[name];
        }

        /**
         * Provides an icon of a module.
         *
         * @method getModuleIcon
         *
         * @param {String} name Name of the module
         *
         * @returns {String} The class of the icon of the module
         */
        function getModuleIcon(name) {
            return MODULE_ICONS[name];
        }

        /**
         * Indicates whether a module can be accessed.
         *
         * @method moduleIsAvailable
         *
         * @param {String} name Name of the module
         * @param {Object} [options] Options for modules that support them
         *
         * @returns {Boolean} Whether the module is available
         */
        function moduleIsAvailable(name, options) {
            var moduleAuthorities;
            if (_currentUserAuthorities) {
                if (name === 'search') {
                    moduleAuthorities = options && options.map ? MODULE_AUTHORITIES.search.map : MODULE_AUTHORITIES.search.global;
                } else if (name === 'riskOneTools') {
                    moduleAuthorities = options && options.subModule ? MODULE_AUTHORITIES.riskOneTools[options.subModule] : MODULE_AUTHORITIES.riskOneTools.riskOneTools;
                } else {
                    moduleAuthorities = MODULE_AUTHORITIES[name];
                }
                return _.difference(moduleAuthorities, _currentUserAuthorities).length === 0;
            } else {
                _currentUserAuthorities = []; // prevent multiple fetches
                SecurityService.getCurrentUserAuthorities()
                    .then(function(authorities) {
                        _currentUserAuthorities = authorities;
                    })
                    .catch(function(reason) {
                        console.error(reason);
                    });
            }
            return false;
        }

        /**
         * Logs the current user out of the application.
         *
         * @method logOut
         */
        function logOut() {
                $window.top.location = applicationContextRoot + '/j_spring_security_logout';
                $window.localStorage.removeItem("logOut");
                $window.localStorage.setItem("logOut","Y");
        }



        function _initBiFrame(id) {
            /* TODO:
                This logic came from MainController. It was for AL-11789. It isn't clear why Cognos
                wouldn't run properly in a basic browser window without help from IRM, but I can't
                look at this due to time constraints. This will cause an infinite loop of timeouts
                if its condition is never met. It needs to be looked at. */

            // this function returns the require function/handler defined inside the Cognos web application engine
            function _getBIRequireHandler() {

                var doc;
                var iframeObj = document.getElementById(id);

                if (iframeObj === null) {
                    return undefined;
                }

                if (iframeObj.contentWindow && iframeObj.contentWindow.require) {
                    return iframeObj.contentWindow.require;
                }

                if (iframeObj.window && iframeObj.window.require) {
                    return iframeObj.window.require;
                }

                if (!doc && iframeObj.contentDocument) {
                    doc = iframeObj.contentDocument.require;
                }

                if (!doc && iframeObj.document) {
                    doc = iframeObj.document.require;
                }

                if (doc && doc.defaultView && doc.defaultView.require) {
                    return doc.defaultView.require;
                }

                if (doc && doc.parentWindow && doc.parentWindow.require) {
                    return doc.parentWindow.require;
                }

                return undefined;
            }

            // this function checks/waits for Cognos web application to be loaded and cognos require to be initialized, and sets the rca window.require to cognos.require
            function _initBIRequireHandler() {
                if (typeof _getBIRequireHandler() !== 'undefined') {
                    window.require = _getBIRequireHandler();
                }
                else {
                    setTimeout(function() { _initBIRequireHandler(); }, 300);
                }
            }

            // this call will trigger the initializaion of the require function/handler
            if (id) {
                _initBIRequireHandler();
            }
        }
    }
})();
